import {branchPath} from '@github-ui/paths'
import {Link as RouterLink} from '@github-ui/react-router'
import {canSoftNavToCodeView, isPullRequestsEnabled} from '@github-ui/repo-app-flags'
import {BranchName} from '@primer/react'
import {Tooltip} from '@primer/react/experimental'
import styles from './PullRequestBranchName.module.css'

export function PullRequestBranchName({
  branchText,
  repositoryOwner,
  repositoryName,
  branch,
  button,
}: {
  branchText: string
  repositoryName: string
  repositoryOwner: string
  branch: string
  button?: React.ReactNode
}) {
  // Soft-navigate only when both the current (pull requests) and destination (code view) apps are
  // mounted in the repo app; otherwise fall back to a full-page navigation.
  const softNav = canSoftNavToCodeView() && isPullRequestsEnabled()

  const name =
    repositoryName && repositoryOwner ? (
      <Tooltip text={`${repositoryOwner}/${repositoryName}:${branch}`}>
        {softNav ? (
          <BranchName
            as={RouterLink}
            to={branchPath({owner: repositoryOwner, repo: repositoryName, branch})}
            className={styles.branchName}
          >
            {branchText}
          </BranchName>
        ) : (
          <BranchName
            href={branchPath({owner: repositoryOwner, repo: repositoryName, branch})}
            className={styles.branchName}
          >
            {branchText}
          </BranchName>
        )}
      </Tooltip>
    ) : (
      <BranchName as="span" className={styles.branchName} title="This repository has been deleted">
        {branchText}
      </BranchName>
    )

  if (!button) return name

  return (
    <span className={styles.branchWithButton}>
      {name}
      {button}
    </span>
  )
}
